import React, { useEffect, useState, useRef } from "react";
import { Navigate, useOutlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { getPageContent, updateCurrentScreen } from "../../utils";

export const ProtectedLayout = () => {
    const { user, isAuthenticated, getUserDetailsNotAsync, getUserDetails, setUserDetailsNotAsync } = useAuth();
    //getUserDetails();
    let userData = getUserDetailsNotAsync();
    const outlet = useOutlet();
    const location = useLocation();
    const navigate = useNavigate();
    const [authenticated, setAuthenticated] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            setLoaded(false);
            try {
                let value = await isAuthenticated();
                setAuthenticated(value);
            } catch {
                setAuthenticated(false);
            } finally {
                setLoaded(true);
            }
        };
        checkAuth();
    }, [location.pathname]);

    if (!loaded) {
        return null; // You can render a loading spinner or message here
    }

    if (
        userData?.applicant?.currentScreen &&
        location.pathname !== "/application-continue" &&
        location.pathname !== "/multiple-application" &&
        location.pathname !== "/application-completion" &&
        location.pathname !== "/apply-now" &&
        location.pathname !== "/payment"
    ) {
        let tab = userData?.applicant?.currentTab?.split(";");
        if (userData?.applicant?.currentTab && tab) {
            if ("/" + userData?.applicant?.currentScreen + "/" + tab[0] + "/" + tab[1] !== location.pathname) {
                return <Navigate to={"/" + userData?.applicant?.currentScreen + "/" + tab[0] + "/" + tab[1]} />;
            }
        } else {
            if ("/" + userData?.applicant?.currentScreen !== location.pathname) {
                return <Navigate to={"/" + userData?.applicant?.currentScreen} />;
            }
        }
    }

    if (user && userData?.applicant && authenticated) {
        let sumittededStatus = ["Submitted", "Processing", "Cancelled", "Declined", "Approved"];
        if (location.pathname === "/application-completion") {
            if (sumittededStatus.indexOf(userData?.applicant?.status) > -1) {
                return <div>{outlet}</div>;
            } else {
                if (userData?.applicant?.currentScreen === "application-completion") {
                    userData = updateCurrentScreen(userData, "application", "");
                } else {
                    userData = updateCurrentScreen(
                        userData,
                        userData?.applicant?.currentScreen,
                        userData?.applicant?.currentTab
                    );
                }

                setUserDetailsNotAsync(userData);
                return <Navigate to={"/"} />;
            }
        } else {
            if (sumittededStatus.indexOf(userData?.applicant?.status) > -1) {
                return <Navigate to={"/application-completion"} />;
            } else {
                return <div>{outlet}</div>;
            }
        }
    }
    return (
        <Navigate
            to={"/signout" + (location.search ? location.search : "") + (location.hash ? location.hash : "")}
            state={{
                path: location.pathname + location.search + location.hash,
                query: (location.search ? location.search : "") + (location.hash ? location.hash : ""),
            }}
        />
    );
};
